import { useCurrenciesStore } from '@st/payments/stores/useCurrenciesStore'
import { currenciesServiceInjectionKey } from '@st/ui/components/CurrencyAmount/types'
import type { CurrenciesServiceData } from '@st/ui/components/CurrencyAmount/types'

/* ! Экспериментальная технология !
   В пакете st-ui есть компонент CurrencyAmount, который зависит от бизнес-логики через provide/inject.
   Для его корректной работы необходима глобальная инициализация данного плагина.
*/
export default defineNuxtPlugin({
  name: 'uiDeps',
  dependsOn: ['paymentsDeps'],
  setup: () => {
    const { getCurrencyById, getCurrencyByCode } = useCurrenciesStore()
    useNuxtApp().vueApp.provide<CurrenciesServiceData>(
      currenciesServiceInjectionKey,
      {
        getCurrencyById,
        getCurrencyByCode,
      },
    )
  },
})
